import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useFormContext } from 'react-hook-form';


import { PayerBasicInformation } from './PayerBasicInformation';
import { PayerBillingInformation } from './PayerBillingInformation';

export function PayersFormStep1({
  onClose,
  setStep,
}: {
  onClose: () => void;
  setStep: (step: number) => void;
}) {
  const form = useFormContext();

  const onNavigateToStep2 = async () => {
    const isValid = await form.trigger();
    if (isValid) {
      setStep(2);
    }
  };

  return (
    <div className="divide-y divide-gray-200 pb-16">
      <PayerBasicInformation />
      <PayerBillingInformation />
      <div className="fixed bottom-0 left-0 right-0 border-t border-gray-200 bg-white p-4">
        <div className="flex justify-end gap-4">
          <Button
            dataTestId="step1-cancel"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => onNavigateToStep2()}
            variant="primary"
            dataTestId="step1-next"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
